import { InvitationCode } from "@utils/enum/CompanyEnum";

export enum BuyerPageRoute {
  LIST = 'list',
}


export const InvitationCodeLotusCOC = [InvitationCode.LOTUS_TH.toString(), InvitationCode.LOTUS_MY.toString()];

export const InvitationCodeKBankCOC = [InvitationCode.KBANK.toString()];